import React, { useEffect, useState } from 'react';

import * as S from './Styled';
import Icon from '../Icon';

const Counter = ({
  name,
  value,
  onChange = () => null,
  increase,
  decrease,
  min = 1,
  max = 5,
  pack_info,
  isInsuranceAgent,
}) => {
  const [input, setInput] = useState(value);

  useEffect(() => {
    setInput(value);
  }, [value]);

  const handleChange = e => {
    return;
    /*let value = e.target.value;
    value = value.replace(/,/g, '.');

    let newValue = '';

    if (isDivisible(pack_info)) {
      if (
        pack_info.quantity_unit_in_pack === 1 &&
        isInsuranceAgent &&
        pack_info.unit_name === 'package'
      ) {
        newValue = value;
      } else {
        newValue = parseInt(value);
      }
    } else {
      newValue = value;
    }

    if (value >= 0 && value < max) {
      setInput(newValue);
      if (onChange) {
        onChange(newValue, name);
      }
    }*/
  };

  return (
    <S.Counter>
      <S.Btn onClick={decrease} disabled={value < min}>
        <Icon name="min" />
      </S.Btn>
      <S.Input
        type="text"
        onChange={handleChange}
        name={name}
        value={input}
        autocomplete="off"
        readOnly
      />
      <S.Btn onClick={increase} disabled={value >= max}>
        <Icon name="plus" />
      </S.Btn>
    </S.Counter>
  );
};

export default Counter;
